"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const clsx_1 = require("clsx");
const prefix = 'tk-typography';
const Typography = (_a) => {
    var { type: type, className, variant } = _a, rest = __rest(_a, ["type", "className", "variant"]);
    const TagName = type === 'body' || type === 'small' ? 'span' : type;
    let variantType = '';
    if (variant) {
        variantType =
            typeof variant === 'string'
                ? `${prefix}--${variant}`
                : variant.map((variantType) => `${prefix}--${variantType}`);
    }
    const classes = (0, clsx_1.clsx)(prefix, `${prefix}--${type}`, variantType, className);
    return (0, jsx_runtime_1.jsx)(TagName, Object.assign({ className: classes }, rest));
};
Typography.defaultProps = {
    type: 'body',
};
exports.default = Typography;
